import { useEffect, useState } from 'react';

// Single responsive breakpoint hook used everywhere we need layout branching.
// Values:
//   'mobile'  →  <  768  (the original phone-first layout, untouched)
//   'tablet'  →  ≥ 768 and < 1280 (no phone frame; wider centered column; bottom tabs)
//   'desktop' →  ≥ 1280 (sidebar nav, multi-column layouts, AI right panel)
//
// We listen on resize so live-reload + window dragging behave correctly.
const TABLET_MIN = 768;
const DESKTOP_MIN = 1280;

function detect() {
  if (typeof window === 'undefined') return 'mobile';
  const w = window.innerWidth;
  if (w >= DESKTOP_MIN) return 'desktop';
  if (w >= TABLET_MIN) return 'tablet';
  return 'mobile';
}

export function useBreakpoint() {
  const [bp, setBp] = useState(detect);
  useEffect(() => {
    const onResize = () => setBp(detect());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return bp;
}

export const isMobile = (bp) => bp === 'mobile';
export const isTablet = (bp) => bp === 'tablet';
export const isDesktop = (bp) => bp === 'desktop';
export const isMobileOrTablet = (bp) => bp !== 'desktop';
